import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { TICKETS_URL } from "@/lib/tickets";

const NAV = [
  { to: "/collector-editions", label: "Collector Editions" },
  { to: "/the-artist", label: "The Artist" },
  { to: "/work", label: "Work" },
  { to: "/exhibitions", label: "Exhibitions" },
  { to: "/chapter-ii", label: "Chapter II" },
  { to: "/press", label: "Press" },
  { to: "/reviews", label: "Reviews" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu on route change
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-40 bg-[color:var(--bone)] text-[color:var(--ink)] border-b border-[color:var(--rule)]"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-5 md:py-6 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-3 md:gap-4"
          data-testid="header-brand"
        >
          <img
            src="/logo-white.png"
            alt=""
            aria-hidden
            className="w-7 h-7 md:w-8 md:h-8 object-contain"
          />
          <span className="font-wordmark text-2xl md:text-3xl tracking-wider leading-none">
            Nick Fraser
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.to.replace(/\//g, "")}`}
              className={({ isActive }) =>
                `hairline transition-opacity duration-500 ${
                  isActive ? "opacity-100" : "opacity-60 hover:opacity-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href={TICKETS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-tickets"
            className="hairline border border-current px-4 py-2 transition-opacity duration-500 opacity-90 hover:opacity-100"
          >
            Tickets
          </a>
        </nav>

        {/* Mobile toggle */}
        <button
          type="button"
          className="md:hidden"
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Close menu" : "Open menu"}
          data-testid="header-mobile-toggle"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {/* Mobile sheet */}
      {open && (
        <div
          className="md:hidden bg-[color:var(--bone)] text-[color:var(--ink)] border-t border-[color:var(--rule)] shadow-xl"
          data-testid="mobile-menu"
        >
          <nav className="px-6 py-8 flex flex-col gap-5">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className="font-serif italic text-2xl"
                data-testid={`mobile-nav-${item.to.replace(/\//g, "")}`}
              >
                {item.label}
              </NavLink>
            ))}
            <a
              href={TICKETS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-nav-tickets"
              className="font-serif italic text-2xl mt-4 inline-block border border-[color:var(--ink)] px-5 py-3 self-start"
            >
              Book Tickets →
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
